import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Title from '@workflow/components/Title.vue'
import ApprovalStatus from '@workflow/components/ApprovalStatus.vue'
import ApprovalInfo from '@workflow/components/ApprovalInfo.vue'
import ProcessLine from '@workflow/components/Read/ProcessLine.vue'
import Iframe from '@workflow/components/Read/Iframe.vue'
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@workflow/store/types'
@Component({
    components: { 
        Title, 
        ApprovalStatus, 
        ApprovalInfo, 
        ProcessLine, 
        Iframe
    },
    computed: {
        ...mapGetters({
            current: types.WORKFLOW_CURRENT,
        })
    }
})
export default class ViewContainer extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    current!: workflow.CM_Form;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    show: boolean = false
    isLoading: boolean = true
    readUrl: string = '';

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    iframeLoading() {
        const _this = this;
        var iframe = window.document.getElementById('workflowFrame'); // workflow iframe div
        //var iframe = frame?.getElementsByTagName('iframe')[0] // iframe
        var contents = (iframe as any).contentDocument; // iframe document 
        
        // 폼 로드 체크
        const loadCheckFn = function() {
            var formBody = contents.querySelector('#formBody'); // 폼 로드 시 무조건 존재
            if (formBody) {
                _this.isloading(false);
                clearInterval(loadCheckInterval);
            }
        };

        var loadCheckInterval = setInterval(loadCheckFn, 1000);
    
        // 폼 로드 10초 이상 지연시 로딩 제거
        setTimeout(function(){
            _this.isloading(false);
            clearInterval(loadCheckInterval);
        }, 10000);
    }

    loadDocument() {
        this.isloading(true);
        var storekey = `s_${Date.now()}`;
        var applicationId = this.current.apm?.applicationId;
        var workflowPageUrl = `/workflow/page/form?apmid=${this.$route.query.apmid}&appid=${applicationId}&storekey=${storekey}&pop=1&frame=true`;
        if (process.env.NODE_ENV === 'development') {
            workflowPageUrl = (window as any).domain + workflowPageUrl
        };
        this.readUrl = workflowPageUrl;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.loadDocument()
    }
}
